import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';

/**
 * FullScreenLoader - polished hydration / boot splash.
 *
 * Rendered by ProtectedRoute / PublicRoute while `isHydrated === false`
 * (auth status === 'loading'). Prevents the brief flash of the
 * unauthenticated branch → false redirect to /login.
 */
export function FullScreenLoader({ label = 'Connecting to the fog…' }: { label?: string }) {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-background">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.45, ease: 'easeOut' }}
        className="relative flex items-center justify-center"
      >
        {/* Outer radar ring */}
        <motion.span
          aria-hidden
          className="absolute h-28 w-28 rounded-full border-2 border-fog/30"
          initial={{ scale: 0.6, opacity: 0.4 }}
          animate={{ scale: [0.6, 1.25], opacity: [0.7, 0] }}
          transition={{ duration: 1.8, repeat: Infinity, ease: 'easeOut' }}
        />
        <motion.span
          aria-hidden
          className="absolute h-28 w-28 rounded-full border-2 border-fog/20"
          initial={{ scale: 0.6, opacity: 0.4 }}
          animate={{ scale: [0.6, 1.25], opacity: [0.7, 0] }}
          transition={{
            duration: 1.8,
            repeat: Infinity,
            ease: 'easeOut',
            delay: 0.6,
          }}
        />
        <Loader2 className="h-10 w-10 animate-spin text-fog" />
      </motion.div>
      <motion.p
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 0.85, y: 0 }}
        transition={{ duration: 0.4, delay: 0.2 }}
        className="mt-6 text-sm font-medium text-muted-foreground"
      >
        {label}
      </motion.p>
    </div>
  );
}
